import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "dark",

    primary: {
      main: "#6B55FF",
      normal: "#7C6AFF",
      light: "#9B8CFF",
      dark: "#4C3ACC",
      low: "#C7C0FF",
      lowOpacity: "#6c55ff16",
      contrastText: "#FFFFFF",
    },

    secondary: {
      main: "#12C895",
      light: "#3DD9AC",
      dark: "#13916d",
      contrastText: "#FFFFFF",
    },

    success: {
      main: "#12C895",
      dark: "#0E9F76",
    },

    error: {
      main: "#FF4D4F",
    },

    warning: {
      main: "#F59E0B",
      light: "#FBBF24",
      dark: "#D97706",
    },

    info: {
      main: "#1B2431",
      light: "#2A3441",
      dark: "#131A24",
    },

    text: {
      primary: "#FFFFFF",
      secondary: "#A1A1AA",
      low: "#6B7280",
      disabled: "#4B5563",
      white: "#FFFFFF",
    },

    grey: {
      500: "#6B7280",
    },

    background: {
      default: "#12161a",
      lightGray: "#2A3441",
      gray: "#2A3441",
      paper: "#1B2431",
      lowOpacity: "#FFFFFF14",
      white: "#FFFFFF",
    },

    common: {
      black: "#000000",
      white: "#FFFFFF",
    },
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 450,
      md: 600,
      lg: 900,
      xlg: 1000,
      xl: 1200,
      xxl: 1500,
      exl: 2000,
      tv: 2500,
    },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontSize: "12px",
          "@media (min-width:600px)": {
            fontSize: "14px",
          },
          "@media (min-width:1200px)": {
            fontSize: "16px",
          },
          "@media (min-width:1500px)": {
            fontSize: "18px",
          },
        },
        body: {
          backgroundColor: "#131A24",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          direction: "rtl",
          "& .MuiSelect-select": {
            textAlign: "right",
            paddingRight: "14px",
            paddingLeft: "32px",
          },
        },
        icon: {
          left: "8px",
          right: "auto",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          direction: "rtl",
          textAlign: "right",
          justifyContent: "flex-start",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          transformOrigin: "top right",
          "&.Mui-focused": {
            transformOrigin: "top right",
          },
        },
        shrink: {
          transformOrigin: "top right",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            textAlign: "right",
          },
        },
        input: {
          textAlign: "right",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          direction: "rtl",
        },
      },
    },
  },
});

export default theme;
